/** Hub-страницы разделов настроек */
export const SETTINGS_ACCESS = '/settings/access';
export const SETTINGS_INTEGRATIONS = '/settings/integrations';
export const SETTINGS_ANALYSIS_HUB = '/settings/analysis';
export const SETTINGS_APPEARANCE = '/settings/appearance';
export const SETTINGS_PERIODS = '/settings/periods';
export const SETTINGS_DEVELOPMENT = '/settings/development';
export const SETTINGS_DEBUG_HUB = '/settings/debug';

/** Детальные страницы */
export const SETTINGS_ANALYSIS_THRESHOLDS = '/settings/analysis/thresholds';
